import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../../interface/component/injected-props.interface';
import styled from 'styled-components';
import { getCDNUrl } from '../../../../util/url/get-cdn-url.util';
import { ColorEnum } from '../../../../enum/color.enum';
import { formLinkFromTemplate } from '../../../../util/url/form-link-from-template';
import { isDraftEmpty } from '../../../../util/draft/is-draft-empty.util';
import { draftToString } from '../../../../util/draft/draft-to-string.util';
import { largeMobileMedia } from '../../../../util/style/large-mobile-media';
import {
  CompanyNameWrapper,
  IBaseJobadProps,
  JobadTagsWrapper, OnlyDesktopTag,
  PositionWrapper,
  StyledPin,
  StyledTag, StyledTime,
  Tag,
  TagText
} from './atoms';
import { BlockColorType } from '../../../../enum/block-color.enum';
import { getLinkFinalURL } from '../../../../util/url/get-link-final-url';
import { SmartLink } from '../../../smart-link/smart-link';
import * as moment from 'moment';
import {getImageCloudinaryURL} from '../../../../util/url/get-image-cloudinary-url.util';

const JOBAD_THUMBNAIL_HORIZONTAL_SIZE = 202;
const JOBAD_THUMBNAIL_VERTICAL_SIZE = 101;
const JOBAD_VERTICAL_MARGIN = 7;

interface IJobadWrapperProps {
  canClick: boolean;
  backgroundColor: BlockColorType;
  hasShadow?: boolean;
}

const JobadWrapper = styled(SmartLink)`
   position: relative;
   width: 100%;
   display: flex;
   justify-content: center;
   margin-top: ${JOBAD_VERTICAL_MARGIN}px;
   margin-bottom: ${JOBAD_VERTICAL_MARGIN}px;
   background-color: ${(props: IJobadWrapperProps) => ColorEnum.getColor(props.backgroundColor)(props as any)};
    ${(props: IJobadWrapperProps) => props.canClick ? 'cursor: pointer;' : ''}
     ${(props: IJobadWrapperProps) => props.hasShadow ? 'box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);' : ''}
`;
const Thumbnail = styled.div`
  background-color: ${ColorEnum.White};
  display: flex;
  justify-content: center;
  align-items: center;
  position:relative;
  padding: 10px;
  box-sizing: border-box;
  flex: 0 0 ${JOBAD_THUMBNAIL_HORIZONTAL_SIZE}px;
  width: ${JOBAD_THUMBNAIL_HORIZONTAL_SIZE}px;
  border-right: 1px solid ${ColorEnum.PearlGray};
  ${largeMobileMedia(`
    display: none;
  `)}
`;
const JobadImage = styled.img`
  margin: 0 20px;
  max-width: ${JOBAD_THUMBNAIL_HORIZONTAL_SIZE - 20}px;
  max-height: ${JOBAD_THUMBNAIL_VERTICAL_SIZE - 20}px;
  height: auto;
  width: auto;
`;
const JobadDetailsWrapper = styled.div`
  width: calc(100% - ${JOBAD_THUMBNAIL_HORIZONTAL_SIZE}px);
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  ${largeMobileMedia(`
    width: 100%;
  `)}
`;

interface IJobadProps extends IBaseJobadProps {
}

@inject('state', 'history')
@observer
export class Jobad extends React.Component<IJobadProps & IInjectedProps> {

  render() {
    const item = this.props.item;
    if (!item) {
      return;
    }
    return (
      <JobadWrapper
        hasShadow={this.props.hasShadow}
        backgroundColor={this.props.jobadBackgroundColor}
        canClick={Boolean(this.props.linkTemplate)}
        to={this.props.linkTemplate ? getLinkFinalURL(this.props.state, formLinkFromTemplate(this.props.linkTemplate, String(item.id)), item) : ''}
      >
        <Thumbnail>
          <JobadImage src={getImageCloudinaryURL(getCDNUrl(this.props.state.configuration, item.companyLogoUrl), JOBAD_THUMBNAIL_HORIZONTAL_SIZE - 20, JOBAD_THUMBNAIL_VERTICAL_SIZE - 20, 'fit')}/>
        </Thumbnail>
        <JobadDetailsWrapper>
          <CompanyNameWrapper>{draftToString(this.props.jobad.line1Text, this.props.state, item)}</CompanyNameWrapper>
          <PositionWrapper color={this.props.applyBeforeBackgroundColor}>{draftToString(this.props.jobad.line2Text, this.props.state, item)}</PositionWrapper>
          {(!isDraftEmpty(this.props.jobad.tagText, this.props.state, item) || !isDraftEmpty(this.props.jobad.line3Text, this.props.state, item)) &&
          <JobadTagsWrapper>
            {!isDraftEmpty(this.props.jobad.line3Text, this.props.state, item) &&
            <Tag backgroundColor={this.props.jobadTagBackgroundColor} textColor={this.props.jobadTagTextColor}>
              <StyledPin/>
              <TagText
                title={draftToString(this.props.jobad.line3Text, this.props.state, item)}
              >
                {draftToString(this.props.jobad.line3Text, this.props.state, item)}
              </TagText>
            </Tag>}
            {!isDraftEmpty(this.props.jobad.tagText, this.props.state, item) &&
            <OnlyDesktopTag backgroundColor={this.props.jobadTagBackgroundColor} textColor={this.props.jobadTagTextColor}>
              <StyledTag/>
              <TagText
                title={draftToString(this.props.jobad.tagText, this.props.state, item)}
              >
                {draftToString(this.props.jobad.tagText, this.props.state, item)}
              </TagText>
            </OnlyDesktopTag>}
            {!isDraftEmpty(this.props.jobad.applyBeforeText, this.props.state, item) &&
            <Tag backgroundColor={this.props.jobadTagBackgroundColor} textColor={this.props.jobadTagTextColor} maxWidth={300}>
              <StyledTime/>
              <TagText
                title={draftToString(this.props.jobad.applyBeforeText, this.props.state, item)}
              >
                {draftToString(this.props.jobad.applyBeforeText, this.props.state, item, undefined, {
                  date: (value => moment(value).format('YYYY-MM-DD'))
                })}
              </TagText>
            </Tag>}
          </JobadTagsWrapper>}
        </JobadDetailsWrapper>
      </JobadWrapper>
    );
  }
}
